import React from "react";
import InstanceLogo from "components/InstanceLogo";

export default class DefaultLogo extends React.Component{
    render() {
        return (
            <InstanceLogo editable={false} />
        );
    }
}